import React from 'react';

import RecorderMain from './RecorderMain';

interface Props {
}

interface State {
}

class MediaRecordingApp extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
    }
  }

  render() {

    return (
      <RecorderMain />
    )
  }

}

export default MediaRecordingApp;
